<template>
  <div>
    <ContentHeader :showBack="true" />
    <div class="content-container" v-loading="loading">
      <div class="steps" v-if="detailInfo.publishStatus === 1">
        <el-steps :active="active" finish-status="success" align-center>
          <el-step title="待提交"></el-step>
          <el-step title="审批中"></el-step>
          <el-step title="生效中"></el-step>
          <el-step title="已结束"></el-step>
        </el-steps>
      </div>
      <div class="steps-disable" v-else>活动已禁用</div>
      <div class="title">
        <span>活动信息</span>
        <!-- <template v-if="employeeLevel <= 50">
          <div class="handle-box" v-if="detailInfo.publishStatus === 1">
            <el-button class="btn-red" v-if="detailInfo.themeStatus !== 200 && detailInfo.themeStatus !== 900" @click="handleUpdate">修改</el-button>
            <el-button class="btn-red" @click="handleCopy">复制</el-button>
            <el-button class="btn-red" v-if="detailInfo.themeStatus <= 100" @click="handleRemove">删除</el-button>
            <el-button class="btn-red" v-if="detailInfo.themeStatus === 200 || detailInfo.themeStatus === 900" @click="handleDisable">禁用</el-button>
          </div>
          <div class="handle-box" v-else>
            <el-button class="btn-red" @click="handleCopy">复制</el-button>
            <el-button class="btn-green" @click="handleEnable">启用</el-button>
          </div>
        </template>
        <template v-else>
          <div v-if="detailInfo.themeStatus === 100">
            <el-button size="mini" type="danger" @click="allPass(200)">通过</el-button>
            <el-button size="mini" type="danger" @click="allPass(0)">驳回</el-button>
          </div>
        </template> -->
      </div>
      <div class="detail-info">
        <div class="detail-item">
          <div class="item-name">主题名称</div>
          <div class="item-value">{{detailInfo.themeName}}</div>
        </div>
        <div class="detail-item">
          <div class="item-name">渠道</div>
          <div class="item-value">{{detailInfo.channelName}}</div>
        </div>
        <div class="detail-item">
          <div class="item-name">活动名称</div>
          <div class="item-value">{{detailInfo.privateThemeName}}</div>
        </div>
        <div class="detail-item">
          <div class="item-name">所属区域</div>
          <div class="item-value">{{detailInfo.orgName}}</div>
        </div>
        <div class="detail-item">
          <div class="item-name">活动时间</div>
          <div class="item-value">{{detailInfo.startDate | parseTime('{y}-{m}-{d}')}}至{{detailInfo.endDate | parseTime('{y}-{m}-{d}')}}</div>
        </div>
        <div class="detail-item">
          <div class="item-name">执行周数</div>
          <div class="item-value" v-if="detailInfo.execWeekChooseType === '01'">{{detailInfo.execWeekMin + '-' + detailInfo.execWeekMax}}</div>
          <div class="item-value" v-if="detailInfo.execWeekChooseType === '02'">{{detailInfo.execWeekScope}}</div>
        </div>
        <div class="detail-item">
          <div class="item-name">陈列追踪方式</div>
          <div class="item-value">{{detailInfo.trackTypeNameScope}}</div>
        </div>
        <div class="detail-item">
          <div class="item-name">费用返还方式</div>
          <div class="item-value">{{detailInfo.bonusTypeNameScope}}</div>
        </div>
        <div class="detail-item" style="flex-basis:100%" v-if="isBonusTypeBeer">
          <div class="item-name" style="flex-basis:12%">赠酒SKU</div>
          <div class="item-value" style="flex-basis:88%;display:flex;flex-wrap:wrap">
            <span class="sku-item" v-for="item in sku" :key="item.skuName">{{item.skuName}}</span>
          </div>
        </div>
        <div class="detail-item" v-if="isBonusTypeFee">
          <div class="item-name">陈列费/周(元)</div>
          <div class="item-value" v-if="detailInfo.bonusFeeChooseType === '01'">{{detailInfo.bonusFeeMin + '-' + detailInfo.bonusFeeMax}}</div>
          <div class="item-value" v-if="detailInfo.bonusFeeChooseType === '02'">{{detailInfo.bonusFeeScope}}</div>
        </div>
        <div class="detail-item" v-if="isBonusTypeBeer">
          <div class="item-name">赠酒数/周(箱)</div>
          <div class="item-value" v-if="detailInfo.bonusBeerChooseType === '01'">{{detailInfo.bonusBeerMin + '-' + detailInfo.bonusBeerMax}}</div>
          <div class="item-value" v-if="detailInfo.bonusBeerChooseType === '02'">{{detailInfo.bonusBeerQtyScope}}</div>
        </div>
        <div class="detail-item">
          <div class="item-name">入账品牌</div>
          <div class="item-value">{{detailInfo.entryBrandCodeName}}</div>
        </div>
        <div class="detail-item" v-if="detailInfo.tradeBudgetTypeDTO">
          <div class="item-name">预算池</div>
          <!-- <div class="item-value">{{budget.typeName }} (可用预算{{budget.availableAmount | thousandSymbol}})</div> -->
          <div class="item-value">{{`${detailInfo.tradeBudgetTypeDTO.typeName} (${detailInfo.tradeBudgetTypeDTO.trCodeName}) - 可用预算：`}}{{detailInfo.tradeBudgetTypeDTO.tradeBudgetInfoCountDTO.availableAmount | thousandSymbol}}</div>
        </div>
        <div class="detail-item">
          <div class="item-name">已选Area</div>
          <div class="item-value">
            <span style="margin-right:20px;padding-bottom:9px" v-for="item in areaList" :key="item.areaCode">{{item.orgName.split('|')[0]}}</span>
          </div>
        </div>
      </div>
      <!-- 执行任务信息 -->
      <div class="exec-task-info" v-show="taskCheckedList.length">
        <!-- tab栏 -->
        <el-tabs v-model="activeName">
          <template v-for="item in taskCheckedList">
            <el-tab-pane v-if="item.checked" :key="item.key" :label="item.title" :name="item.title"></el-tab-pane>
          </template>
        </el-tabs>
        <!-- 选项卡 -->
        <!-- 堆箱任务 -->
        <div class="tab-content" v-show="activeName==='堆箱任务'">
          <div class="tab-item encourage">
            <p>激励金额配置</p>
            <div class="encourage-input">
              <span>单张拍照激励金额</span>
              <!-- <el-input v-model="taskPackSelected.incentiveFee" disabled placeholder="请输入激励金额" /> -->
              <div style="line-height:38px">{{taskPackSelected.incentiveFee | thousandSymbol}}</div>
            </div>
          </div>
          <DisplayPackDesign
            type="view"
            v-show="taskPackSelected.mixinPackScopeList && taskPackSelected.mixinPackScopeList.length"
            :selectedData="taskPackSelected.mixinPackScopeList"
          ></DisplayPackDesign>
          <DisplayMixin
            style="margin-top:5px"
            type="view"
            v-show="taskPackSelected.mixinDisplayScopeList && taskPackSelected.mixinDisplayScopeList.length"
            :selectedData="taskPackSelected.mixinDisplayScopeList"
          ></DisplayMixin>
        </div>
        <!-- 货架任务 -->
        <div class="tab-content" v-show="activeName==='货架任务'">
          <div class="tab-item encourage">
            <p>激励金额配置</p>
            <div class="encourage-input">
              <span>单张拍照激励金额</span>
              <!-- <el-input v-model="taskShelfSelected.incentiveFee" disabled placeholder="请输入激励金额" /> -->
              <div style="line-height:38px">{{taskShelfSelected.incentiveFee | thousandSymbol}}</div>
            </div>
          </div>
          <DisplayMandatory
            type="view"
            v-show="taskShelfSelected.mandatoryScopeList && taskShelfSelected.mandatoryScopeList.length"
            :selectedData="taskShelfSelected.mandatoryScopeList"
          ></DisplayMandatory>
          <DisplayMixin
            style="margin-top:5px"
            type="view"
            v-show="taskShelfSelected.mixinDisplayScopeList && taskShelfSelected.mixinDisplayScopeList.length"
            :selectedData="taskShelfSelected.mixinDisplayScopeList"
          ></DisplayMixin>
        </div>
        <!-- 冰柜任务 -->
        <div class="tab-content" v-show="activeName==='冰柜任务'">
          <div class="tab-item encourage">
            <p>激励金额配置</p>
            <div class="encourage-input">
              <span>单张拍照激励金额</span>
              <!-- <el-input v-model="taskFreezerSelected.incentiveFee" disabled placeholder="请输入激励金额" /> -->
              <div style="line-height:38px">{{taskFreezerSelected.incentiveFee | thousandSymbol}}</div>
            </div>
          </div>
          <DisplayMandatory
            type="view"
            v-show="taskFreezerSelected.mandatoryScopeList && taskFreezerSelected.mandatoryScopeList.length"
            :selectedData="taskFreezerSelected.mandatoryScopeList"
          ></DisplayMandatory>
          <DisplayMixin
            style="margin-top:5px"
            type="view"
            v-show="taskFreezerSelected.mixinDisplayScopeList && taskFreezerSelected.mixinDisplayScopeList.length"
            :selectedData="taskFreezerSelected.mixinDisplayScopeList"
          ></DisplayMixin>
        </div>
      </div>
      <div class="nothing" v-if="!taskCheckedList.length">您暂未配置执行任务信息</div>
      <!-- 操作记录 -->
      <div class="title">
        <span>操作记录</span>
      </div>
      <div class="handle-history">
        <el-table :data="history" style="width: 100%" :border="true">
          <el-table-column prop="processClientName" label="操作人" align="center">
            <template #default="scope">
              <div>{{scope.row.employeeLevelName + ' - ' + scope.row.processClientName}}</div>
            </template>
          </el-table-column>
          <el-table-column prop="processActionName" label="操作" align="center"></el-table-column>
          <el-table-column prop="processRemark" label="备注" align="center"></el-table-column>
          <el-table-column prop="processTime" label="时间" align="center">
            <template #default="scope">{{scope.row.processTime | parseTime("{y}-{m}-{d} {h}:{i}:{s}")}}</template>
          </el-table-column>
        </el-table>
      </div>
    </div>
  </div>
</template>

<script>
import tradeApi from '@/api/trade'
import ContentHeader from '@/components/content-header'
import DisplayPackDesign from '@/views/trade/perfect2022/components/display-pack-design'
import DisplayMixin from '@/views/trade/perfect2022/components/display-mixin'
import DisplayMandatory from '@/views/trade/perfect2022/components/display-mandatory'
import { mapGetters } from 'vuex'
export default {
  components: {
    ContentHeader,
    DisplayPackDesign,
    DisplayMixin,
    DisplayMandatory
  },
  computed: {
    ...mapGetters(['userInfo']),
    sku () {
      // let skuName = ''
      let list = []
      if (this.detailInfo.bonusBeerScope) {
        // skuName = JSON.parse(this.detailInfo.bonusBeerScope)[0].skuName
        list = JSON.parse(this.detailInfo.bonusBeerScope)
        // JSON.parse(this.detailInfo.bonusBeerScope).forEach(item => {
        //   skuName += item.skuName
        // })
      }
      return list
    },
    budget () {
      let obj = {}
      if (this.detailInfo.budgetInfoList) {
        obj = this.detailInfo.budgetInfoList[0]
      }
      return obj
    },
    active () {
      let status = null
      switch (this.detailInfo.themeStatus) {
        case 0:
          status = 0
          break
        case 100:
          status = 1
          break
        case 200:
          status = 2
          break
        case 900:
          status = 3
          break
      }
      return status
    },
    isBonusTypeBeer () {
      return this.detailInfo.bonusTypeScope?.indexOf('03') !== -1
    },
    isBonusTypeFee () {
      return this.detailInfo.bonusTypeScope?.indexOf('02') !== -1 || this.detailInfo.bonusTypeScope?.indexOf('01') !== -1
    },
    isBonusTypeFeeOnLine () {
      return this.detailInfo.bonusTypeScope?.indexOf('01') !== -1
    }
  },
  data () {
    return {
      loading: false,
      input: '',
      activeName: '堆箱任务',
      min: 3,
      max: 5,
      isShowAddPlaceDesign: false,
      isShowShelfEssential: false,
      taskCheckedList: [],
      detailInfo: {},
      taskPackSelected: [],
      taskShelfSelected: [],
      taskFreezerSelected: [],
      pageInfo: {
        currentPage: 1,
        pageSize: 5,
        total: 0
      },
      history: [],
      employeeLevel: null,
      areaList: []
    }
  },
  created () {
    this.employeeLevel = this.userInfo.employeeLevel
    this.getDetailInfo()
  },
  methods: {
    // 获取活动详情
    getDetailInfo () {
      this.loading = true
      tradeApi.getBuPerfectTasksConfigInfo({ themeDefineId: this.$route.query.themeDefineId }).then(res => {
        if (res.data.resultCode === '0') {
          this.loading = false
          this.detailInfo = res.data.resultData.tradePerfectThemeDefineDTO
          this.history = res.data.resultData.tradePerfectThemeDefineDTO.commonProcessRecordDTOList
          this.getTask()
          this.getTaskCheckedList()
          // this.getHandleHistory()
          this.getAreaList()
        }
      })
    },
    // 获取areaList
    getAreaList () {
      tradeApi.getAreaList({ regionCode: this.detailInfo.orgCode }).then(res => {
        if (res.data.resultCode === '0') {
          let list = res.data.resultData.regionList
          if (this.detailInfo.areaCodes && this.detailInfo.areaCodes.length) {
            this.areaList = this.detailInfo.areaCodes.split(',').map(item => {
              for (let i = 0; i < list.length; i++) {
                if (list[i].orgCode === item) {
                  return list[i]
                }
              }
            })
          } else {
            this.areaList = list
          }
        }
      })
    },
    // 获取已选择任务
    getTask () {
      this.detailInfo.tradePerfectTaskDefineList.forEach(item => {
        if (item.taskType === '01') {
          this.taskPackSelected = item
        } else if (item.taskType === '02') {
          this.taskShelfSelected = item
        } else if (item.taskType === '03') {
          this.taskFreezerSelected = item
        }
      })
    },
    // 任务选项卡
    getTaskCheckedList () {
      if (!this.detailInfo.taskTypeScope.length) {
        return
      }
      this.taskCheckedList = this.detailInfo.taskTypeScope.split(',').map(item => {
        item = { key: item }
        item.checked = true
        if (item.key === '01') {
          item.title = '堆箱任务'
        } else if (item.key === '02') {
          item.title = '货架任务'
        } else if (item.key === '03') {
          item.title = '冰柜任务'
        }
        return item
      })
      this.activeName = this.taskCheckedList[0].title
    },
    // 复制
    handleCopy () {
      this.$router.push({
        path: '/perfect-region-config',
        query: { type: 'copy', themeDefineId: this.detailInfo.themeDefineId, orgCode: this.detailInfo.orgCode }
      })
    },
    // 修改
    handleUpdate () {
      this.$router.push({
        path: '/perfect-region-config',
        query: { type: 'update', themeDefineId: this.detailInfo.themeDefineId, orgCode: this.detailInfo.orgCode }
      })
    },
    // 禁用
    handleDisable () {
      this.$prompt('请输入禁用原因:', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputPattern: /\S+/,
        inputErrorMessage: '请输入禁用原因'
      }).then(({ value }) => {
        if (!value) {
          this.$message.warning('请填写禁用原因')
          return
        }
        tradeApi.handleRegionDisable({ themeDefineId: this.detailInfo.themeDefineId, processRemark: value }).then(res => {
          if (res.data.resultCode === '0') {
            this.$message.success('禁用成功')
            this.$router.go(0)
          }
        })
      }).catch(() => {

      })
    },
    // 启用
    handleEnable () {
      this.$prompt('请输入启用备注:', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(({ value }) => {
        tradeApi.handleRegionEnable({ themeDefineId: this.detailInfo.themeDefineId, processRemark: value }).then(res => {
          if (res.data.resultCode === '0') {
            this.$message.success('启用成功')
            this.$router.go(0)
          }
        })
      }).catch(() => {

      })
    },
    // 删除活动
    handleRemove (rowData) {
      this.$confirm(`是否删除活动:  ${this.detailInfo.privateThemeName}`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        tradeApi.handleRegionRemove({ themeDefineId: this.detailInfo.themeDefineId }).then(res => {
          if (res.data.resultCode === '0') {
            this.$message.success('删除成功')
            this.$router.push({
              path: '/trade/perfect-region-config-list'
            })
          }
        })
      }).catch(() => {

      })
    },
    // bu 审批
    allPass (themeStatus) {
      let params = [{ themeDefineId: this.$route.query.themeDefineId, themeStatus }]
      let mag = themeStatus === 200 ? '审批通过' : '驳回'
      if (themeStatus === 200) {
        this.$prompt('请输入审批通过原因', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消'
        }).then(({ value }) => {
          params.map(item => {
            item.processRemark = value
            return item
          })
          tradeApi.perfectApproval(params).then(res => {
            if (res.data.resultCode === '0') {
              this.$message.success(mag + '成功')
              this.getApprovalList()
            }
          })
        }).catch(() => { })
      } else {
        this.$prompt('请输入审批驳回原因', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          inputPattern: /\S/,
          inputErrorMessage: '请输入审批驳回原因'
        }).then(({ value }) => {
          params.map(item => {
            item.processRemark = value
            return item
          })
          console.log(params)
          tradeApi.perfectApproval(params).then(res => {
            if (res.data.resultCode === '0') {
              this.$message.success('驳回成功')
              this.getApprovalList()
            }
          })
        }).catch(() => { })
      }
    }
  }

}
</script>

<style lang="scss" scoped>
::v-deep .el-step__title.is-process,
::v-deep .el-step__head.is-process {
  color: #cd1231;
  border-color: #cd1231;
  font-weight: 400;
}
::v-deep .el-step__head.is-success,
::v-deep .el-step__head.is-process {
  font-size: 14px;
}
.el-button {
  width: 50px;
  height: 30px;
  padding: 0;
}
.content-container {
  width: 1200px;
  .steps {
    padding: 25px 100px;
    background-color: #fff;
    border-radius: 10px;
  }
  .steps-disable {
    background-color: #fff;
    color: #cd1231;
    text-align: center;
    padding: 50px 0;
  }
  .title {
    display: flex;
    justify-content: space-between;
    align-items: center;
    span {
      font-size: 18px;
      font-weight: 700;
      line-height: 60px;
      padding-left: 10px;
    }
  }
  .detail-info {
    display: flex;
    flex-wrap: wrap;
    background-color: #fff;
    padding: 20px;
    border-radius: 10px;
    margin-bottom: 40px;
    .detail-item {
      width: 50%;
      display: flex;
      flex-wrap: wrap;
      .item-name {
        width: 130px;
        height: 48px;
        flex-basis: 25%;
      }
      .item-value {
        flex-basis: 70%;
        white-space:normal;
        word-break:break-all;
        word-wrap:break-word;
      }
    }
  }
}
// // 任务tabs样式
::v-deep .el-tabs {
  .el-tabs__header {
    border-bottom: none;
  }
  .el-tabs__nav {
    border: none;
    border-radius: 10px 10px 0px 0px;
    background-color: #fff;
    padding: 10px 20px 0px;
  }
  .el-tabs__header {
    margin: 0;
  }
  .el-tabs__nav-wrap::after {
    background-color: #f3f5f9;
  }
  .el-tabs__active-bar {
    margin: 0 20px 0;
    background-color: rgb(234, 84, 5);
  }
  .el-tabs__item.is-active {
    font-weight: 700;
    color: rgb(234, 84, 5);
  }
  .el-tabs__item:hover {
    color: rgb(234, 84, 5);
  }
}
.tab-content {
  font-size: 16px;
  border-radius: 0px 10px 10px 10px;
  overflow: hidden;
  position: relative;
  .tab-item {
    background-color: #fff;
    padding: 20px 20px;
  }
}
.place-title {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: #fff;
  padding: 20px 20px 0;
  p {
    font-weight: 700;
    margin: 0;
  }
  .el-button {
    width: 80px;
  }
}
.handle-history {
  background-color: #fff;
  border-radius: 10px;
  padding: 30px;
}
.btn-green {
  background-color: #64d795;
  color: #fff;
}
.encourage {
  margin-bottom: 5px;
  background-color: #fff;
  padding: 30px 20px 20px;
  p {
    font-weight: 700;
    margin-top: 0;
    font-size: 16px;
  }
  .encourage-input {
    display: flex;
    &::v-deep .el-input .el-input__inner {
      height: 30px;
    }
    .el-input {
      width: 135px;
      height: 30px;
    }
    span {
      line-height: 38px;
      font-size: 14px;
      margin-right: 20px;
    }
  }
}
.nothing {
  text-align: center;
  background-color: #fff;
  padding: 120px 0;
  border-radius: 10px;
}
.sku-item {
  // line-height: 48px;
  // padding-bottom: 33px;
  display: block;
  height: 48px;
  margin-right: 30px;
  padding-left: 5px;
}
</style>
